import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendExtractedBlogDescriptionFromUrl,
  BackendQueryBlogUrlExtractedDescriptionArgs,
} from 'src/types/backend';

const MUTATION = gql`
  query BlogUrlExtractedDescription($id: ID!) {
    blogUrlExtractedDescription(id: $id) {
      extractionErrors
      status
      description
    }
  }
`;

type Variables = BackendQueryBlogUrlExtractedDescriptionArgs;
type Result = Pick<
  BackendExtractedBlogDescriptionFromUrl,
  'extractionErrors' | 'status' | 'description'
>;

export const queryBlogUrlExtractedDescription = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
